export default {"src":"/_next/static/media/chapter-1-icon-circular.fc23317e.svg","height":137,"width":138,"blurWidth":0,"blurHeight":0};